import * as ReactModule from 'react'
import * as ReactDOM from 'react-dom'

/**
 * Пробрасывает React и ReactDOM в globalThis для inline-плагинов (moduleCode).
 *
 * Проблема: Blob URL не имеет доступа к Vite-резолверу,
 * поэтому `import React from 'react'` внутри не работает.
 *
 * Решение: объявляем глобальные переменные ДО загрузки плагинов.
 * Плагин использует: const { useState } = React  или просто React.createElement()
 *
 * Для moduleUrl этот bridge не нужен — файл может импортировать React
 * через esm.sh: import React from 'https://esm.sh/react@18'
 *
 * Вызывается ПЕРВЫМ в bootstrap.ts.
 */
export function setupReactBridge(): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const g = globalThis as any
  g['React']       = ReactModule
  g['ReactDOM']    = ReactDOM
  // Удобные шорткаты для плагинов
  g['useState']    = ReactModule.useState
  g['useEffect']   = ReactModule.useEffect
  g['useRef']      = ReactModule.useRef
  g['useCallback'] = ReactModule.useCallback
  g['useMemo']     = ReactModule.useMemo
}
